import type { ListingImportQueueItem } from '../types/listing-import-queue-item';

export function isListingImportActiveWork(
  queue: ListingImportQueueItem[]
): boolean {
  return queue.some(item =>
    ['queued', 'uploading', 'processing'].includes(item.status)
  );
}
